export default {
    title: 'Γρήγορη αναζήτηση',
    placeholder: 'Αναζήτησε πελάτες, πρότυπα, σελίδες…',
    cancel: 'Άκυρο',
    groups: {
        recent: 'Πρόσφατοι πελάτες',
        clients: 'Πελάτες',
        actions: 'Ενέργειες',
        pages: 'Σελίδες',
        dietPlans: 'Πρότυπα πλάνα',
        recipes: 'Συνταγές',
    },
    actions: {
        newClient: 'Νέος πελάτης',
        newClientHint: 'Γρήγορη προσθήκη',
        newAppointment: 'Νέο ραντεβού',
        aCloud: 'Άνοιγμα aCloud',
    },
    allClients: 'Όλοι οι πελάτες για «{query}» ({count})',
    searching: 'Αναζήτηση…',
    noResults: {
        title: 'Δεν βρέθηκε τίποτα για «{query}»',
        hint: 'Δοκίμασε όνομα, κινητό ή email πελάτη, ή το όνομα μιας σελίδας.',
    },
    keys: {
        navigate: 'μετακίνηση',
        open: 'άνοιγμα',
        close: 'κλείσιμο',
    },
}
